const PERCENTUAL = new Intl.NumberFormat("pt-BR", {
  style: "percent",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const MOEDA = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

const MOEDA_SEM_SIGLA = new Intl.NumberFormat("pt-BR", {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const DECIMAL = new Intl.NumberFormat("pt-BR", { style: "decimal", maximumFractionDigits: 0 });

export function formatterPercent(valor: number) {
  return PERCENTUAL.format(valor);
}

export function formatterCurrency(valor: number) {
  return MOEDA.format(valor);
}

export function formatterCurrencySemSigla(valor: number) {
  return MOEDA_SEM_SIGLA.format(valor);
}

export function formatterDecimal(valor: number) {
  return DECIMAL.format(valor);
}
